import DraftJSPluginEditor from 'draft-js-plugin-editor';
import React from 'react';
import { Editor, DefaultDraftInlineStyle, DraftEditorContents } from 'draft-js';

const React_createElement = React.createElement;

// Patch over draft js render for android
const React_createElementOverride = function (Component, props, ...rest) {
  const isDraftContents = (
    props &&
    'blockRenderMap' in props &&
    'blockRendererFn' in props &&
    'blockStyleFn' in props &&
    'customStyleMap' in props &&
    'customStyleFn' in props &&
    'editorKey' in props &&
    'editorState' in props
  );

  const isEditor = (
    !isDraftContents &&
    props &&
    props.key === 'editor' + this.state.containerKey
  );

  if (isDraftContents) {
    props.key = 'contents' + this.state.containerKey;
  }
  else if (isEditor) {
    delete props.key;
  }

  return React_createElement.call(React, Component, props, ...rest)
};

const Editor_render = Editor.prototype.render;
Editor.prototype.render = function render() {
  React.createElement = React_createElementOverride.bind(this);
  var component = Editor_render.call(this);
  React.createElement = React_createElement;

  return component;
};

export default DraftJSPluginEditor;



// WEBPACK FOOTER //
// ./assets/es6/view_invitation/common/components/editor.es6